import { ApiError, convertObjectToJson } from '@gorila-shared-ui/components';
import { post } from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth';
import { environment } from '../environments/environment';
import { BulkEventSettingRequest, EventSettingRequest } from '../types/eventSetting';
import { User } from '../types/user';
import { getErrorMessage } from '../utils/apiErrorResponse';
import { getRequest, postRequest } from './api';
import { accountEventsBulkUrl, accountEventsUrl, accountUrl } from './urls/accountUrls';

export const getAccount = async (): Promise<{ account?: User; error?: ApiError }> => {
  const response = await getRequest(accountUrl);
  return {
    account: response?.data,
    error: response?.error,
  };
};

export const changePassword = async (params = {}): Promise<{ data?: any; error?: ApiError }> => {
  try {
    const response = await post({
      apiName: environment.awsChangePaswordApiEndpointName,
      path: 'change-password/',
      options: {
        ...convertObjectToJson(params),
        headers: {
          Authorization: `Bearer ${(await fetchAuthSession()).tokens?.accessToken}`,
        },
      },
    }).response;
    try {
      return {
        data: await response.body?.json(),
      };
    } catch {
      return {
        data: undefined,
      };
    }
  } catch (error) {
    return {
      error: getErrorMessage(error, { params, path: 'change-password/' }),
    };
  }
};

export const updateEvent = async (eventSetting: EventSettingRequest): Promise<{ error?: ApiError }> => {
  const response = await postRequest(accountEventsUrl, {
    body: { ...eventSetting },
  });

  return {
    error: response?.error,
  };
};

export const updateEventsInCategory = async (
  bulkEventSetting: BulkEventSettingRequest,
): Promise<{ error?: ApiError }> => {
  const response = await postRequest(accountEventsBulkUrl, {
    body: { ...bulkEventSetting },
  });

  return {
    error: response?.error,
  };
};
